import { Constants } from "./constants";

export class Shelf {
    public bookIds: Array<String> = new Array<String>();
    public createdAt: Number = 0;
    public owner: String = Constants.USER;
    public title: String = '';
    public type: String = 'shelf';
    public shelfType: String = '';
    public category: Number = 0;
    public _id: String = "";

    public parentId: String = "";
    public children: Array<String> = new Array<String>();
    public level: Number = 0;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/shelf.ts